import { render, staticRenderFns } from "./EModalGerarMensalidades.vue?vue&type=template&id=56370957"
import script from "./EModalGerarMensalidades.vue?vue&type=script&lang=js"
export * from "./EModalGerarMensalidades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports